import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Stack,
  Typography
} from '@mui/material';

import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

const RESORT_ADDRESSES = {
  MRÓWKI: {
    name: 'Ośrodek Wypoczynkowy MRÓWKI',
    address: 'Mrówki',
    postalCode: '62-550',
    city: 'Kownaty'
  },

  GIEWARTÓW: {
    name: 'Ośrodek GIEWARTÓW',
    address: 'ul. Armii Krajowej 123',
    postalCode: '62-402',
    city: 'Giewartów'
  }
};

export const ResortAddressCard = ({
  orderData
}) => {
  const resort =
    RESORT_ADDRESSES[
      orderData.resort_name
    ] || {
      name: orderData.resort_name,
      address: '-',
      postalCode: '',
      city: ''
    };

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2]
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={4}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <LocationOnOutlinedIcon color="primary" />
          </Box>

          <Typography
            variant="h4"
            fontWeight={700}
          >
            Adres ośrodka
          </Typography>
        </Stack>

        <Stack spacing={1}>
          <Typography
            variant="h5"
            fontWeight={700}
          >
            {resort.name}
          </Typography>

          <Typography>
            {resort.address}
          </Typography>

          <Typography>
            {resort.postalCode}{' '}
            {resort.city}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};
